<template>
  <label
    class="ms-radio"
    @keypress="keyDownActive"
    @focus="onFocus"
    @blur="onBlur"
  >
	<input
	type="radio"
	:name="name"
	:value="keyValue"
	:checked="value"
	v-model="value"
	@input="$emit('input',keyValue)"
	@change="$emit('change',$event)"
	:disabled="disabled"
	>
	<span class="checkmark"></span>
	<span v-if="label" class="ms-radio--text">{{label}}</span>
  </label>
</template>
<script>
export default {
  name: "msRadio",
  props: {
    value: {},
    label: {
      default: null,
      type: String
    },
    keyValue: {
      default: null
    },
    name: {
      default: null,
      type: String
    },
    type: {
      default: "radio",
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      focused: false   
    };
  },
  methods: {
    keyDownActive(e) {
      e.preventDefault();
      switch (e.which) {
        case 32:
        case 13:
          this.$emit("input", this.keyValue);
          this.$el.querySelector('input[type="radio"]').focus()
          break;
      }
    },
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners
      };
    },
    checkHasEvent(){
      let me = this;
      if(me.checked){
        return true;
      }
    }
  },
  
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/components/MsRadio.scss";
</style>

